import CollectionsList from "./CollectionsList";

export default {
    list: CollectionsList,
};
